




























































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import YcColorPicker from '@/components/color-picker/index.js';
import compontentForm from '../../../components/form.vue';
import TextAlignPicker from '@/components/text-align/index.js';
import { typesettingOptions, typesettingOptionsLeftRightOnly, typesettingOptionsFullscreen, fontFaceList, predefineColors, formAddList, borderRadiusOptions, borderStyleOptions, fontSizeOptions, backgroundOptions, COUPON_SIZE_TIP } from '../../../constant/options';
import { MultipleDiscountOption, PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import discountDialog from '../../../components/discountDialog.vue';
import PopUnifiedDiscountSettingsDialog from '@/views/wheelOfFortune/components/PopUnifiedDiscountSettingsDialog.vue';
import DiscountList from './DiscountList.vue';
import FontPicker from '@/components/FontPicker/index.vue';
import { getCompanyInfo } from '@/model/CompanyInfo';
import EventBus from '@/utils/eventBus';
import { getFontFaceList } from '@/utils/getFontFaceList';
import { getVueAppUploadApi } from '@/services/util';
import { ensureFileScopeAuthorized } from '@/services/fileScope';
import CloseButtonSetting from './CloseButtonSetting.vue';
import { isEnableCloseButtonAdvanced, isEnablePopUnifiedDiscountCode } from '@/utils/experiment';
import InfoPopover from '@/views/wheelOfFortune/components/InfoPopover.vue';
import { isEnableCouponSize } from '@/utils/isEnableCouponSize';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'compontent-form': compontentForm,
    discountDialog: discountDialog,
    PopUnifiedDiscountSettingsDialog,
    'text-align-picker': TextAlignPicker,
    'close-button-setting': CloseButtonSetting,
    'discount-list': DiscountList,
    'font-picker': FontPicker,
    "info-popover": InfoPopover,
  }
})
export default class wheelOfFortuneTextEnd extends Vue {
  @Prop(String)
  activePageSetting!: string;

  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;
  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;
  discountValueTip = COUPON_SIZE_TIP;

  // 折扣值能力需要走公司灰度，并排除单步骤模板
  get enableCouponSize() {
    const templateId = String(this.$route.query.templateid || this.formDataStart?.templateId || this.formData?.templateId || '');
    return isEnableCouponSize(templateId);
  }

  get isFullscreenPopupLayout() {
    return this.formDataStart.settings.rules.popupLayoutMode === 'fullscreen';
  }

  get isPureWheelTemplate() {
    return Number(this.formDataStart?.popWindowWheel) === 1;
  }

  get typesettingOptionsForEndPage() {
    if (this.isFullscreenPopupLayout) {
      return this.isPureWheelTemplate ? this.typesettingOptionsLeftRightOnly : this.typesettingOptionsFullscreen;
    }
    return this.typesettingOptions;
  }

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  @Prop({ type: String, default: 'success' })
  subscribeStatus!: string;

  // 选择框选项
  get formAddList() {
    if (this.formData.settings.combinationType == 2) {
      return formAddList.filter(item => {
        if (item.label != 'Email') {
          return item;
        }
      });
    } else {
      return formAddList;
    }
  }
  predefineColors = predefineColors;
  fontFaceList = getFontFaceList(fontFaceList);
  borderRadiusOptions = borderRadiusOptions;
  borderStyleOptions = borderStyleOptions;
  fontSizeOptions = fontSizeOptions;
  backgroundOptions = backgroundOptions;
  typesettingOptions = typesettingOptions;
  typesettingOptionsLeftRightOnly = typesettingOptionsLeftRightOnly;
  typesettingOptionsFullscreen = typesettingOptionsFullscreen;

  emailOpen: boolean = this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'end';
  couponCodeShow: boolean = this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'end';
  collapseArr = ['1', '2'];
  formList = this.formData.settings.end;
  compontentFormIsShow = false;
  formType = {};

  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  bgUploadFileList: { name: string; url: string }[] = [];
  bgUploadShow = false;

  // 订阅成功文本区图片
  unsubscribedTextAreaUploadShow = false;
  unsubscribedTextAreaFileList: { name: string; url: string }[] = [];
  // 历史已订阅文本区图片
  subscribedTextAreaUploadShow = false;
  subscribedTextAreaFileList: { name: string; url: string }[] = [];

  showDiscountDialog = false;

  discountList: Array<MultipleDiscountOption> = [];

  get enableFormOptimize() {
    return true;
  }

  get enableCloseButtonAdvanced() {
    return isEnableCloseButtonAdvanced();
  }

  get enableImageEnd() {
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;
    return [30, 1892, 2042, 2044, 2058, 2059, 2075, 2076].includes(companyId);
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1;
  }

  get currentSubscribeStatus() {
    // 默认显示订阅成功状态
    return this.subscribeStatus || 'success';
  }

  get enableWheelCouponSetting() {
    return this.formDataStart.settings.discountList && this.formDataStart.popWindowWheel === 1;
  }

  get company33aPopDisable() {
    const disablePop =
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 33 && this.formData?.id == '55abadf02473424aa42004745e4b74f6') ||
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 30 && this.formData?.id == '8eaf5e5c7d244b65bc9843e98f33d08d');
    return disablePop;
  }

  get formStyle() {
    const rules = this.formDataStart.settings.rules;
    return `
      .cartx-option-columns{
        min-width: ${Math.floor(100 / (rules.optionColumns || 1)) - 3}%!important;
        color: ${rules.optionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.optionBackground}!important;
        background: ${rules.optionBackground}!important;
      }
      .cartx-question {
        color: ${rules.optionColor}!important;
      }
      .cartx-form .el-input__inner {
        border-width: ${rules.inputType === 'bottom' ? '0 0 1px 0' : '1px'}!important;
        border-style: ${rules.inputBorderStyle}!important;
        border-color: ${rules.inputBorderColor}!important;
        border-radius: ${rules.inputBorderRadius}!important;
        background: ${rules.inputBackgroundShow !== 'none' ? rules.inputBackground : 'none'}!important;
        color: ${rules.inputColor}!important;
      }
      .cartx-form input::-webkit-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input::-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-ms-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
    `;
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return (
      this.formData.popWindowWheel === 1 ||
      tid === '36' ||
      tid === '37' ||
      tid === '38' ||
      tid === '39' ||
      tid === '40' ||
      tid === '42' ||
      tid === '43' ||
      `${this.formData.id}` === '1e1609bc024d4517989039886ac7ed34' ||
      `${this.formData.id}` === 'abdac5d809824d8280ffff395a854a15'
    );
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return ((companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681)) && this.triggerEventType !== 3;
  }

  /** 仅决定弹出哪种折扣码设置弹窗；入口/触发条件与线上一致 */
  get useUnifiedDiscountSettings() {
    return isEnablePopUnifiedDiscountCode();
  }

  discountType = 'guding';

  gaClickFun(key:string,name:string){
    window?.gtagClick(key,name)
  }

  changeShowSuccessDiffPage() {
    window?.gtagClick('form_edit_cdiffEndPage', '弹窗_编辑订阅工具_差异结束页');

    // 当关闭差异展示页面开关时，清空subscribeStatus状态并联动关闭多折扣券包
    if (!this.formDataStart.settings.rules.showSuccessDiffPage) {
      // 通过事件总线通知父组件清空subscribeStatus
      EventBus.$emit('clear-subscribe-status');
      // 联动关闭展示多折扣券包
      // this.formDataStart.settings.rules.multipleDiscountShow = false;
    }
    
    this.changeStart();
  }


  // TODO: discountType联动
  changeDiscountType() {
    if (this.discountType === 'guding') {
      this.formDataStart.settings.discount = null;
      this.showDiscountDialog = false;
    } else {
      this.showDiscountDialog = true;
    }
    // this.discountType = 'guding';
    // this.formDataStart.settings.discountType = 'guding';

    // 保存到formDataStart中
    this.formDataStart.settings.discountType = this.discountType;
    // 发送事件通知其他组件
    EventBus.$emit('discount-type-changed', this.discountType);
    this.changeStart();
  }
  showDiscountDialogHandle() {
    this.showDiscountDialog = true;
  }
  handleDiscountListChange(list: MultipleDiscountOption[]) {
    // 折扣券列表变更时的处理
    this.discountList = list;
    // 保存到 formDataStart.settings 中以便预览组件访问
    // 使用 $set 确保响应式更新
    this.$set(this.formDataStart.settings, 'multipleDiscountList', list);
    const firstCoupon = list?.[0];
    this.formDataStart.settings.rules.couponCode = firstCoupon?.couponCode || '';
    if (this.enableCouponSize) {
      this.$set(this.formDataStart.settings.rules, 'couponSize', firstCoupon?.couponSize || '');
    }
    this.changeStart();
  }
  handleSetDynamic(index: number) {
    // 设置动态折扣码时的处理，可以打开对话框或导航到设置页面
    // 传入 index 以标识是哪个折扣券
    // TODO: 实现动态折扣码设置逻辑
    // this.currentDiscountIndex = index;
    // this.showDiscountDialog = true;
  }
  changeMultipleDiscountShow() {
    const isShow = (this.formDataStart.settings.rules as any).multipleDiscountShow;

    if (isShow) {
      // 当开启展示多折扣券包时，从formDataStart.settings中获取配置，列表只会存在一个
      this.discountList = [{
        couponPrompt: this.formDataStart.settings.texts.couponPrompt || '',
        discountType: this.formDataStart.settings.discountType || 'guding',
        couponCode: this.formDataStart.settings.rules.couponCode || '',
        couponSize: this.enableCouponSize ? (this.formDataStart.settings.rules.couponSize || '') : '',
      }];
    } else {
      // 当关闭展示多折扣券包时，只保留列表中的一个，并赋值给formDataStart.settings
      if (this.discountList.length > 0) {
        const firstDiscount = this.discountList[0];
        if (firstDiscount) {
          // 将第一个折扣码的配置赋给原有字段
          this.formDataStart.settings.texts.couponPrompt = firstDiscount.couponPrompt || '';
          this.formDataStart.settings.discountType = firstDiscount.discountType || 'guding';
          this.formDataStart.settings.rules.couponCode = firstDiscount.couponCode || '';
          if (this.enableCouponSize) {
            this.$set(this.formDataStart.settings.rules, 'couponSize', firstDiscount.couponSize || '');
          }
        }
        // 只保留列表中的第一个元素
        this.discountList = [this.discountList[0]];
      } else {
        // 如果列表为空，初始化一个空元素
        this.discountList = [{
          couponPrompt: this.formDataStart.settings.texts.couponPrompt || '',
          discountType: this.formDataStart.settings.discountType || 'guding',
          couponCode: this.formDataStart.settings.rules.couponCode || '',
          couponSize: this.enableCouponSize ? (this.formDataStart.settings.rules.couponSize || '') : ''
        }];
      }
    }

    // 保存到 formDataStart.settings 中
    // 使用 $set 确保响应式更新
    window?.gtagClick('form_edit_couponPack','弹窗_编辑订阅工具_券包');
    this.$set(this.formDataStart.settings, 'multipleDiscountList', this.discountList);
    this.changeStart();
  }
  saveDiscount(discount: any) {
    this.formDataStart.settings.rules.couponCode = '';
    this.formDataStart.settings.discount = discount;
    this.formDataStart.settings.discountType = 'dongtai';
    this.discountType = 'dongtai';
    // 发送事件通知
    EventBus.$emit('discount-type-changed', 'dongtai');
    this.showDiscountDialog = false;
    this.changeStart();
  }
  closeDiscount() {
    if (this.discountType === 'guding') {
      // this.formDataStart.settings.discountType = 'guding';
      this.discountType = 'guding';
      // this.changeStart();
    }
    this.showDiscountDialog = false;
  }

  changeFormList(e: any) {
    this.formDataStart.settings.end = e;
    this.changeStart();
  }
  changcompontentFormIsShow(e: boolean) {
    this.compontentFormIsShow = e;
  }

  changeImgPosition() {
    const ts = this.formDataStart?.settings?.typesetting;
    if (ts?.imgPosition != 'background') {
      ts.bgbox = false;
    }
    if (this.isFullscreenPopupLayout && ts?.imgPosition === 'background') {
      ts.bgbox = false;
    }
    this.changeStart();
  }

  changeStart() {
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }
  changeStartGA() {
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }

  handleCloseButtonChange(config: any) {
    // 同步更新老的 endCloseColor 以保持兼容
    if (config && config.iconColor) {
      this.formDataStart.settings.rules.endCloseColor = config.iconColor;
      // 同时更新 start 页的 closeColor 确保一致性
      if (!this.formDataStart.settings.rules.closeColor) {
        this.formDataStart.settings.rules.closeColor = config.iconColor;
      }
    }
    this.changeStart();
    window?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  changeCouponCodePosition() {
    if (this.couponCodeShow) {
      if (this.formData.settings.rules.couponCodePosition === 'start') {
        this.$message.warning('开始页面已经展示coupon');
        this.couponCodeShow = false;
      } else {
        this.formDataStart.settings.rules.couponCodePosition = 'end';
        this.formDataStart.settings.rules.couponCodeShow = this.couponCodeShow;
      }
    } else {
      if (this.formData.settings.rules.couponCodePosition === 'start') {
        this.formData.settings.rules.couponCodePosition = 'start';
      } else {
        this.formData.settings.rules.couponCodePosition = '';
      }
      // 浮条的开启，前置条件coupon展示必须也要开启；浮条可以单独开启关闭；coupon展示关闭，浮条则关闭
      this.formData.settings.banner.floatBannerShow = false;
      // 关闭展示 Coupon 时同步清空折扣值，避免隐藏配置继续参与后续发码记录
      this.$set(this.formDataStart.settings.rules, 'couponSize', '');
    }
    this.changeStart();
  }
  changeCouponCodeType() {
    this.changeStart();
  }
  addFormAddList(item: any, index: number) {
    if (this.collapseArr.indexOf('1') < 0) {
      this.collapseArr.push('1');
    }
    if (item.type !== '自定义') {
      let a = this.formList.filter((i: any) => {
        return i.type === item.type;
      });

      if (a.length > 0) {
        this.formType = a[0];
        this.compontentFormIsShow = true;
        return;
      }
      let b = this.formDataStart.settings.start.filter((i: any) => {
        return i.type === item.type;
      });
      if (b.length > 0) {
        this.$message.error('您添加了多个' + item.label + '表单，请检查设置是否有误');
        return;
      }
    }
    if (this.formList.length < 8) {
      this.formType = item;
      this.compontentFormIsShow = true;
    } else {
      this.$message.error('最多只能添加8个表单');
    }
    window?.gtagClick('form_edit_selectField_'+item?.label.replace(/\s/g, ''),'弹窗_编辑订阅工具_选择采集项_'+item?.label.replace(/\s/g, ''))
  }

  @Watch('formData.settings.typesetting.imgUrl', { immediate: true })
  typesettingImgUrlChange(val: string) {
    // console.log('typesettingImgUrlChange', val);
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.imgUrlEnd', { immediate: true })
  typesettingImgUrlEndChange(val: string) {
    // console.log('typesettingImgUrlEndChange', val);
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.rules.emailOpen')
  emailOpenChange(val: boolean) {
    if (val === true && this.formData.settings.rules.emailPosition === 'end') {
      this.emailOpen = true;
    }
  }

  @Watch('formData.settings.rules.emailPosition')
  emailPositionChange(val: string) {
    if (this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'end') {
      this.emailOpen = true;
    }
  }

  @Watch('formData.settings.rules.couponCodeShow')
  couponCodeShowChange(val: boolean) {
    if (val === true && this.formData.settings.rules.couponCodePosition === 'end') {
      this.couponCodeShow = true;
    }
  }

  @Watch('formData.settings.rules.couponCodePosition')
  couponCodePositionChange(val: string) {
    if (this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'end') {
      this.couponCodeShow = true;
    }
  }

  mounted() {
    // 优先从配置中加载 multipleDiscountList
    if (this.formDataStart.settings.multipleDiscountList && this.formDataStart.settings.multipleDiscountList.length > 0) {
      this.discountList = this.formDataStart.settings.multipleDiscountList;
    } else if (this.discountList.length === 0 && this.enableSubscribeDifferentPage) {
      // 如果配置中没有且 discountList 为空，从现有配置初始化
      this.discountList = [{
        couponPrompt: this.formDataStart.settings.texts.couponPrompt || '',
        discountType: this.formDataStart.settings.discountType || (this.formDataStart.settings.discount ? 'dongtai' : 'guding'),
        couponCode: this.formDataStart.settings.rules.couponCode || '',
        couponSize: this.enableCouponSize ? (this.formDataStart.settings.rules.couponSize || '') : ''
      }];
      // 保存到 formDataStart.settings 中
      // 使用 $set 确保响应式更新
      this.$set(this.formDataStart.settings, 'multipleDiscountList', this.discountList);
    }
    
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.discountType = 'guding';
    } else {
      this.discountType = 'dongtai';
    }
  }

  @Watch('formData', { immediate: true })
  changeFormData() {
    this.formDataStart = this.formData;
    // if (!this.formDataStart.settings.discountType) {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.discountType = 'guding';
    } else {
      this.discountType = 'dongtai';
    }
    // }
  }

  @Watch('formData.settings.end')
  changeEndFormList(val: any) {
    this.formList = val;
  }

  /**
   * 图片上传失败钩子函数
   */
  bgHandleError(e: any): void {
    this.bgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  bgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.bgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      if (this.enableImageEnd) {
        this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrlEnd = res.data[0].url);
      } else {
        this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = res.data[0].url);
      }
      this.bgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.bgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  bgBeforeUpload(file: { type: string; size: number }): boolean | Promise<boolean> {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/webp";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    return ensureFileScopeAuthorized().then(() => {
      this.bgUploadShow = true;
      return true;
    });
  }
  /**
   * 删除图片
   */
  bgUploadUrlDelete() {
    // console.log('bgUploadUrlDelete', this.bgUploadShow, this.formDataStart?.settings?.typesetting);
    this.bgUploadShow = false;
    if (this.enableImageEnd) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrlEnd = '');
    } else {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = '');
    }
    this.$forceUpdate();
    this.changeStart();
    // console.log('bgUploadUrlDelete end', this.bgUploadShow, this.formDataStart?.settings?.typesetting);
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }

  // ===== 订阅成功文本区图片上传 =====
  @Watch('formData.settings.texts.unsubscribedTextAreaImgUrl', { immediate: true })
  unsubscribedTextAreaImgUrlChange(val: string) {
    if (val) {
      this.unsubscribedTextAreaUploadShow = true;
      this.unsubscribedTextAreaFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.unsubscribedTextAreaUploadShow = false;
      this.unsubscribedTextAreaFileList = [];
    }
  }

  unsubscribedTextAreaHandleError(e: any): void {
    this.unsubscribedTextAreaUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      this.$alert('登录失效，请重新登录');
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }

  unsubscribedTextAreaHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.unsubscribedTextAreaUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.texts && (this.formDataStart.settings.texts.unsubscribedTextAreaImgUrl = res.data[0].url);
      this.unsubscribedTextAreaFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.unsubscribedTextAreaUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }

  unsubscribedTextAreaBeforeUpload(file: { type: string; size: number }): boolean | Promise<boolean> {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/webp";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    return ensureFileScopeAuthorized().then(() => {
      this.unsubscribedTextAreaUploadShow = true;
      return true;
    });
  }

  unsubscribedTextAreaUploadUrlDelete() {
    this.unsubscribedTextAreaUploadShow = false;
    this.unsubscribedTextAreaFileList = [];
    this.formDataStart?.settings?.texts && (this.formDataStart.settings.texts.unsubscribedTextAreaImgUrl = '');
    this.changeStart();
  }

  // ===== 历史已订阅文本区图片上传 =====
  @Watch('formData.settings.texts.subscribedTextAreaImgUrl', { immediate: true })
  subscribedTextAreaImgUrlChange(val: string) {
    if (val) {
      this.subscribedTextAreaUploadShow = true;
      this.subscribedTextAreaFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.subscribedTextAreaUploadShow = false;
      this.subscribedTextAreaFileList = [];
    }
  }

  subscribedTextAreaHandleError(e: any): void {
    this.subscribedTextAreaUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      this.$alert('登录失效，请重新登录');
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }

  subscribedTextAreaHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.subscribedTextAreaUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.texts && (this.formDataStart.settings.texts.subscribedTextAreaImgUrl = res.data[0].url);
      this.subscribedTextAreaFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.subscribedTextAreaUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }

  subscribedTextAreaBeforeUpload(file: { type: string; size: number }): boolean | Promise<boolean> {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/webp";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    return ensureFileScopeAuthorized().then(() => {
      this.subscribedTextAreaUploadShow = true;
      return true;
    });
  }

  subscribedTextAreaUploadUrlDelete() {
    this.subscribedTextAreaUploadShow = false;
    this.subscribedTextAreaFileList = [];
    this.formDataStart?.settings?.texts && (this.formDataStart.settings.texts.subscribedTextAreaImgUrl = '');
    this.changeStart();
  }
}
